<template>
    <div>
        <label
            v-for="(label, index) in labels"
            :key="`label-${name}-${index}`"
            :for="`input-${name}-${index}`"
            class="bbox-checkbox-label"
            style="cursor:pointer"
        >
            <div class="display-flex align-items-center">
                <input
                    type="checkbox"
                    :id="`input-${name}-${index}`"
                    :name="name"
                    :value="labelsValues[index]"
                    v-model="selectedOptions"
                >
                <div class="checkbox-icon">
                    <b-icon v-if="isSelected(labelsValues[index])"><icon-check-box/></b-icon>
                    <b-icon v-else><icon-check-box-outline-blank/></b-icon>
                </div>
                <slot name="label" :data="label"/>
                <span :class="labelClasses" v-if="typeof $scopedSlots.label === 'undefined' && !!label">{{ label }}</span>
            </div>
            <span class="input-error font-size-big red-base margin-top-tiny" v-if="!!error"><b-icon><icon-error-outline/></b-icon> {{ error }}</span>
        </label>
    </div>
</template>

<script>
import BIcon from './Icon.vue';

export default {
    name: 'b-multi-checkbox',
    components: {
        BIcon
    },
    props: {
        /**
        * Name do checkbox
        */
        name: {
            type: String,
            required: true
        },
        /**
        * Dados do label dos checkboxes
        */
        labels: {
            type: Array,
            default: () => []
        },
        /**
        * Valores dos checkboxes
        */
        labelsValues: {
            type: Array,
            default: () => []
        },
        /**
         * Valores selecionados nos checkboxes
         * @model
         */
        value: {
            type: Array,
            default: () => []
        },
        /**
        * Mensagem de erro
        */
        error: {
            type: String,
            default: ''
        },
        /**
        * Classes para estilizar o label
        */
        labelClasses: {
          type: String,
          default: "font-size-big ink semi-bold"
        },
    },
    computed: {
        selectedOptions: {
            get() {
                return this.value;
            },
           /**
           * Evento emitido quando usuário troca o valor de alguma das opções do multi-checkbox
           * @property {value} valor selecionado no multi-checkbox
           * @type {input}
           */
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        isSelected(value) {
            return this.value.includes(value);
        }
    }
}
</script>

<style scoped lang="scss">
    .container-checkbox{
        align-items: flex-start;
    }
    input{
        display: none;
    }
    span.input-error {
        display: block;
        text-align: left;
        line-height: 1.2;
    }
    .checkbox-icon{
        margin-right: 5px;
        margin-top: -1.5px;
        font-size: 2rem;
    }
</style>

<docs>
    BMultiCheckbox

    ```js
    const testOptions = ['HTML', 'CSS', 'Javascript', 'Node'];
    let targetTests = []

    <b-multi-checkbox
        name="tests"
        :labels="testsOptions"
        :labelsValues="testsOptions"
        v-model="targetTests">
    </b-multi-checkbox>
    ```
</docs>
